export const YM_ID = 97741921;
export const YD_NEW_ID = 98013145;
